module.exports = __webpack_public_path__ + "img/map.3f1c2e9b.png";